import React from 'react';
import { roleLabel } from '../../../../../utils/workspaceAccess';
import { initialsFor, inviteIsOpen } from '../utils/peopleUtils';

export function InviteRow({ invite, copiedId, cancellingId, onCopy, onCancel }) {
  const expired = !inviteIsOpen(invite);

  return (
    <li className="settings-people__row">
      <span
        className="settings-people__avatar settings-people__avatar--pending"
        aria-hidden="true"
      >
        {initialsFor(invite.email)}
      </span>
      <div className="settings-people__who">
        <span className="settings-people__name">{invite.email}</span>
        <span className="settings-people__sub">
          {roleLabel(invite.role)} · invited
        </span>
      </div>
      <div className="settings-people__row-end">
        <span
          className={`settings-people__pill ${
            expired ? 'settings-people__pill--stale' : ''
          }`}
        >
          {expired ? 'Expired' : 'Pending'}
        </span>
        {!expired && (
          <button
            type="button"
            className="settings-people__link"
            onClick={() => onCopy(invite)}
          >
            {copiedId === invite.id ? 'Copied' : 'Copy link'}
          </button>
        )}
        <button
          type="button"
          className="settings-people__link settings-people__link--danger"
          disabled={cancellingId === invite.id}
          onClick={() => onCancel(invite)}
        >
          {cancellingId === invite.id ? 'Cancelling…' : 'Cancel'}
        </button>
      </div>
    </li>
  );
}
